import Title from "~/components/product/ProductDescription/Title"
export interface Props {
    category: string
    inProductGroupWithID: string
    name: string
    image?: string
}

export default function Reviews({ inProductGroupWithID }: Props) {
    return (
        <div className='w-full md:w-1/2'>
            <Title>AVALIAÇÕES</Title>

            <div className='container-center mb-[124px]'>
                {/* Konfidency - detalhes das avaliações na PDP */}
                <div
                    id='konfidency-reviews'
                    className='konfidency-reviews-details scroll-mt-16'
                    data-sku={inProductGroupWithID}
                    suppressHydrationWarning
                    dangerouslySetInnerHTML={{ __html: '' }}
                />
            </div>
        </div>
    )
}
